 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"b-modal~dashboard":"b-modal~dashboard","b-modal":"b-modal","b-loading-spinner":"b-loading-spinner","k-link":"k-link","dashboard":"dashboard","add-edit-advertiser":"add-edit-advertiser","add-edit-pixel":"add-edit-pixel","add-edit-user":"add-edit-user","add-organization":"add-organization","add-user":"add-user","b-dropdown-select-account":"b-dropdown-select-account","b-email-btn":"b-email-btn","b-filter-top-bar":"b-filter-top-bar","b-flip-header":"b-flip-header","b-multi-email-btn":"b-multi-email-btn","b-numero":"b-numero","b-radio-select-checkbox":"b-radio-select-checkbox","b-radio-tab":"b-radio-tab","b-select-checkbox":"b-select-checkbox","b-table-report-builder":"b-table-report-builder","dash-export-table":"dash-export-table","dash-graphs-panel":"dash-graphs-panel","flip-pixel":"flip-pixel","k-download-btn":"k-download-btn","performance-panel":"performance-panel","add-account~add-account-wizard":"add-account~add-account-wizard","add-account":"add-account","add-account-wizard":"add-account-wizard","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676":"dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676","dash-summary-stats":"dash-summary-stats","donut-chart":"donut-chart","halo-effect~incrementality":"halo-effect~incrementality","incrementality":"incrementality","horizontal-bar-chart":"horizontal-bar-chart","line-chart":"line-chart","multi-country-map-chart":"multi-country-map-chart","view-pixel":"view-pixel","menu-icon":"menu-icon","brand-lift~daily-view-new-chart~distribution-chart":"brand-lift~daily-view-new-chart~distribution-chart","brand-lift":"brand-lift","daily-view-new-chart":"daily-view-new-chart","distribution-chart":"distribution-chart","halo-effect":"halo-effect","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056":"dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056","dash-ad-groups-performance-table":"dash-ad-groups-performance-table","dash-audiences-performance-table":"dash-audiences-performance-table","dash-creatives-performance-table":"dash-creatives-performance-table","dash-media-types-performance-table":"dash-media-types-performance-table","dash-publishers-performance-table":"dash-publishers-performance-table","flip-quick-stats":"flip-quick-stats","bar-chart":"bar-chart","b-icon-select-checkbox":"b-icon-select-checkbox","multi-axes-line-chart":"multi-axes-line-chart","k-diff-pill":"k-diff-pill","b-performance-table":"b-performance-table","semi-circle":"semi-circle"}[chunkId]||chunkId) + "." + {"b-modal~dashboard":"4de3d09f","b-modal":"28bb85a3","chunk-38ea5b98":"dca61a56","b-loading-spinner":"fdf6a662","chunk-2d0cfa5b":"8ad04783","chunk-0896ee51":"0d597f1f","chunk-a7d0306c":"6bba523e","chunk-6aa2d766":"9d2f0329","k-link":"404f0026","dashboard":"acf457da","add-edit-advertiser":"60c2e6fa","add-edit-pixel":"ed58e175","add-edit-user":"564dbfdc","add-organization":"c2191f8c","add-user":"97eed69f","b-dropdown-select-account":"6009751f","b-email-btn":"be47494f","b-filter-top-bar":"1db12ce1","b-flip-header":"af9539d7","b-multi-email-btn":"36cb57e4","b-numero":"e2f7a053","b-radio-select-checkbox":"632b20ed","b-radio-tab":"34157c10","b-select-checkbox":"a786021a","b-table-report-builder":"1fb80dd2","chunk-d57ceea8":"a0815dcc","dash-export-table":"b1b9d713","dash-graphs-panel":"999e7017","flip-pixel":"c194f69a","k-download-btn":"29b9f1ad","performance-panel":"22ce815f","add-account~add-account-wizard":"c109779e","add-account":"38a65c57","add-account-wizard":"3957fd73","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676":"a60858da","dash-summary-stats":"9320d769","donut-chart":"11e5282a","halo-effect~incrementality":"9425a56a","incrementality":"c87898ce","horizontal-bar-chart":"1d900469","line-chart":"99096f3c","multi-country-map-chart":"550a1f06","view-pixel":"665a445f","menu-icon":"dab11333","brand-lift~daily-view-new-chart~distribution-chart":"69a58bcf","brand-lift":"ca8861fe","daily-view-new-chart":"608c1359","distribution-chart":"3d207497","halo-effect":"556b6c63","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056":"1d55866e","dash-ad-groups-performance-table":"f284c7d9","dash-audiences-performance-table":"d9fdbc60","dash-creatives-performance-table":"a6cf845b","dash-media-types-performance-table":"b9803147","dash-publishers-performance-table":"b71ea826","flip-quick-stats":"6b9697a0","bar-chart":"b23d1101","b-icon-select-checkbox":"082bf7f8","multi-axes-line-chart":"07f031d1","k-diff-pill":"61681b9d","b-performance-table":"5ead48d0","semi-circle":"b167d676"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"b-modal~dashboard":1,"b-modal":1,"chunk-38ea5b98":1,"b-loading-spinner":1,"chunk-0896ee51":1,"chunk-a7d0306c":1,"chunk-6aa2d766":1,"dashboard":1,"add-edit-advertiser":1,"add-edit-pixel":1,"add-edit-user":1,"add-organization":1,"add-user":1,"b-dropdown-select-account":1,"b-email-btn":1,"b-filter-top-bar":1,"b-flip-header":1,"b-multi-email-btn":1,"b-numero":1,"b-radio-select-checkbox":1,"b-radio-tab":1,"b-select-checkbox":1,"b-table-report-builder":1,"chunk-d57ceea8":1,"dash-export-table":1,"dash-graphs-panel":1,"flip-pixel":1,"k-download-btn":1,"performance-panel":1,"add-account":1,"add-account-wizard":1,"donut-chart":1,"incrementality":1,"horizontal-bar-chart":1,"line-chart":1,"multi-country-map-chart":1,"view-pixel":1,"menu-icon":1,"brand-lift":1,"daily-view-new-chart":1,"distribution-chart":1,"halo-effect":1,"dash-ad-groups-performance-table":1,"dash-audiences-performance-table":1,"dash-creatives-performance-table":1,"dash-media-types-performance-table":1,"dash-publishers-performance-table":1,"flip-quick-stats":1,"bar-chart":1,"b-icon-select-checkbox":1,"multi-axes-line-chart":1,"k-diff-pill":1,"b-performance-table":1,"semi-circle":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"b-modal~dashboard":"b-modal~dashboard","b-modal":"b-modal","b-loading-spinner":"b-loading-spinner","k-link":"k-link","dashboard":"dashboard","add-edit-advertiser":"add-edit-advertiser","add-edit-pixel":"add-edit-pixel","add-edit-user":"add-edit-user","add-organization":"add-organization","add-user":"add-user","b-dropdown-select-account":"b-dropdown-select-account","b-email-btn":"b-email-btn","b-filter-top-bar":"b-filter-top-bar","b-flip-header":"b-flip-header","b-multi-email-btn":"b-multi-email-btn","b-numero":"b-numero","b-radio-select-checkbox":"b-radio-select-checkbox","b-radio-tab":"b-radio-tab","b-select-checkbox":"b-select-checkbox","b-table-report-builder":"b-table-report-builder","dash-export-table":"dash-export-table","dash-graphs-panel":"dash-graphs-panel","flip-pixel":"flip-pixel","k-download-btn":"k-download-btn","performance-panel":"performance-panel","add-account~add-account-wizard":"add-account~add-account-wizard","add-account":"add-account","add-account-wizard":"add-account-wizard","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676":"dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676","dash-summary-stats":"dash-summary-stats","donut-chart":"donut-chart","halo-effect~incrementality":"halo-effect~incrementality","incrementality":"incrementality","horizontal-bar-chart":"horizontal-bar-chart","line-chart":"line-chart","multi-country-map-chart":"multi-country-map-chart","view-pixel":"view-pixel","menu-icon":"menu-icon","brand-lift~daily-view-new-chart~distribution-chart":"brand-lift~daily-view-new-chart~distribution-chart","brand-lift":"brand-lift","daily-view-new-chart":"daily-view-new-chart","distribution-chart":"distribution-chart","halo-effect":"halo-effect","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056":"dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056","dash-ad-groups-performance-table":"dash-ad-groups-performance-table","dash-audiences-performance-table":"dash-audiences-performance-table","dash-creatives-performance-table":"dash-creatives-performance-table","dash-media-types-performance-table":"dash-media-types-performance-table","dash-publishers-performance-table":"dash-publishers-performance-table","flip-quick-stats":"flip-quick-stats","bar-chart":"bar-chart","b-icon-select-checkbox":"b-icon-select-checkbox","multi-axes-line-chart":"multi-axes-line-chart","k-diff-pill":"k-diff-pill","b-performance-table":"b-performance-table","semi-circle":"semi-circle"}[chunkId]||chunkId) + "." + {"b-modal~dashboard":"d7fcbe4f","b-modal":"39187493","chunk-38ea5b98":"d7506e53","b-loading-spinner":"f9ab7e19","chunk-2d0cfa5b":"31d6cfe0","chunk-0896ee51":"8d79f7e4","chunk-a7d0306c":"b52badc0","chunk-6aa2d766":"97d0e45f","k-link":"31d6cfe0","dashboard":"0dc7bc26","add-edit-advertiser":"033bdfc9","add-edit-pixel":"31c4107d","add-edit-user":"81275f4d","add-organization":"fa1fe7f7","add-user":"2822f65e","b-dropdown-select-account":"7e48ef73","b-email-btn":"6de37e5a","b-filter-top-bar":"f9b2e4d1","b-flip-header":"51eabdeb","b-multi-email-btn":"9d2b2182","b-numero":"abf6eaf2","b-radio-select-checkbox":"2f418dba","b-radio-tab":"07132a24","b-select-checkbox":"6b0cbced","b-table-report-builder":"4bf3e9a8","chunk-d57ceea8":"e129f72c","dash-export-table":"292a6201","dash-graphs-panel":"4cd88912","flip-pixel":"aa4f31d7","k-download-btn":"f8b222c6","performance-panel":"d043c51e","add-account~add-account-wizard":"31d6cfe0","add-account":"4a2fb816","add-account-wizard":"a0ddcf63","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~c8a33676":"31d6cfe0","dash-summary-stats":"31d6cfe0","donut-chart":"1faf6bbb","halo-effect~incrementality":"31d6cfe0","incrementality":"0b33bdb0","horizontal-bar-chart":"da1572ca","line-chart":"933bc2e9","multi-country-map-chart":"15bfe79a","view-pixel":"c034ee1b","menu-icon":"a59135b2","brand-lift~daily-view-new-chart~distribution-chart":"31d6cfe0","brand-lift":"df98b772","daily-view-new-chart":"5fd10ef4","distribution-chart":"9afca6ab","halo-effect":"ded82183","dash-ad-groups-performance-table~dash-audiences-performance-table~dash-creatives-performance-table~d~de766056":"31d6cfe0","dash-ad-groups-performance-table":"678f0d0a","dash-audiences-performance-table":"9572b92f","dash-creatives-performance-table":"88830a00","dash-media-types-performance-table":"cc58039a","dash-publishers-performance-table":"7399b088","flip-quick-stats":"ffb61d23","bar-chart":"e2ea2446","b-icon-select-checkbox":"48884edc","multi-axes-line-chart":"f25bdad5","k-diff-pill":"8a5fc67b","b-performance-table":"0bef848c","semi-circle":"315eb342"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
